<div class="chat-container">
  <!-- Message Display Area -->
  <div class="message-area" #messageArea>
    <div *ngFor="let message of displayMessages" class="chat-message" [ngClass]="'message-' + message.role">
      <div class="message-content" [innerHTML]="message.content"></div>

      <!-- Sources Expander -->
      <div *ngIf="message.role === 'assistant' && message.sources && message.sources.length > 0" class="sources-container">
        <details>
          <summary>View Sources</summary>
          <ul class="sources-list">
            <li *ngFor="let source of message.sources">
              <pre>{{ source.page_content }}</pre>
            </li>
          </ul>
        </details>
      </div>
    </div>
    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="chat-message message-assistant">
        <div class="spinner"></div>
    </div>
  </div>

  <!-- User Input Area -->
  <div class="input-area">
    <form (ngSubmit)="sendMessage()">
      <input
        type="text"
        [(ngModel)]="userInput"
        name="userInput"
        placeholder="Ask me anything about your system configurations..."
        [disabled]="isLoading"
        autocomplete="off"
      />
      <button type="submit" [disabled]="isLoading">Send</button>
    </form>
  </div>
</div>
